import React from "react";
import cx from "clsx";
export var CategoryPanel = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.shapeClass, shapeClass = _b === void 0 ? "rounded-b-lg" : _b, _c = _a.transitionClass, transitionClass = _c === void 0 ? "duration-400 ease-linear md:duration-200 md:ease-in-out" : _c;
    var baseClass = "cat-panel";
    var layoutClass = "md:flex md:absolute z-50 justify-between overflow-hidden md:max-h-120";
    var colorClass = "bg-white";
    return (React.createElement("div", { className: cx(baseClass, layoutClass, shapeClass, colorClass, transitionClass, className) }, children));
};
//# sourceMappingURL=CategoryPanel.js.map